module.exports = __webpack_public_path__ + "img/right-arrow-offer.6f34b200.svg";